<template>
  <div class="zero-form note-editor">
    <template v-if="editNotes">
      <textarea
        id="note"
        name="note"
        placeholder=""
        class="standard-text-area width-100 mb-x1"
        v-model="editValue"
        autocomplete="off"
      >
      </textarea>
      <button @click="putNotes()" class="zero-btn zero-btn-standard zero-btn-primary mb-x1 zero-btn-full slim">
        <i class="far fa-sticky-note mr-x1"></i>Save Note
      </button>
      <!-- canceling is keeping v-model - port content to edit v-model and port back on save -->
      <button @click="cancelEdit()" class="zero-btn zero-btn-standard zero-btn-primary zero-btn-outline mb-x1 zero-btn-full slim">
        <i class="far fa-sticky-note mr-x1"></i>Cancel
      </button>
    </template>
    <div class="loading-container" v-else-if="isLoading">
      <div class="spinning-loader loader-md active"></div>
    </div>
    <template v-else>
      <div class="notes-container" v-if="notes">
        <p class="pre-wrap mb-x2">{{ notes }}</p>
        <button @click="editNotes = true" class="zero-btn zero-btn-standard zero-btn-primary zero-btn-outline mb-x1 zero-btn-full slim on-dark">
          <i class="far fa-sticky-note mr-x1"></i>Edit Note
        </button>
      </div>
      <template v-else>
        <button @click="editNotes = true" class="zero-btn zero-btn-standard zero-btn-primary zero-btn-outline mb-x1 zero-btn-full slim">
          <i class="far fa-sticky-note mr-x1"></i>Add Note
        </button>
      </template>
    </template>
  </div>
</template>

<script>
const axios = require('axios')

// endpoints
const apiChoice = process.env.VUE_APP_API_URL

export default {
  name: 'DatesList',
  props: {
    id: {
      type: Number
    },
    notesProp: {
      type: String,
      default: ''
    },
    jwt: {
      type: String
    }
  },
  watch: {
    notesProp: function () {
      this.setNotes()
    }
  },
  data () {
    return {
      isLoading: false,
      editNotes: false,
      notes: '',
      editValue: ''
    }
  },
  components: {},
  created () {
    this.setNotes()
  },
  mounted () {},
  computed: {},
  methods: {
    setNotes () {
      this.notes = this.notesProp
      this.editValue = this.notesProp
    },
    cancelEdit () {
      this.editNotes = false
      this.editValue = this.notes
    },
    putNotes () {
      this.isLoading = true
      this.editNotes = false
      let shotNotes = { 'extraone': this.editValue }
      axios
        .put(apiChoice + 'api/shots/' + this.id, shotNotes, {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.jwt
          }
        })
        .then((response) => {
          this.isLoading = false
          this.notes = response.data.extraone
          // stop loading
          // this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
          // this.isLoading = false
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.note-editor{
  width: 100%;
}
.loading-container{
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.notes-container{
  background: #298DAD;
  color: #fff;
  margin: 0px -20px -20px;
  width: calc(100% + 40px);
  padding: 20px;
}
// Media Queries
// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {
}
// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
}
// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
}
// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
}
</style>
